<main class="main-content-login">
    <div class="box-login space-y-10">
        <div class="box-login__logo">
            <img src="/assets/img/logo-nova-vida-login.png" alt="">
        </div>
        <form (keyup.enter)="login()">
            <input type="text"
                   class="form-input rounded px-4 py-2"
                   placeholder="e-mail"
                   [(ngModel)]="email"
                   name="email">
            <div class="password-wrapper mt-2">
                <input [type]="showPassword ? 'text' : 'password'"
                       class="form-input rounded px-4 py-2"
                       placeholder="Insira sua senha"
                       [(ngModel)]="senha"
                       name="password">
                <button type="button"
                        class="toggle-password"
                        (click)="togglePasswordVisibility()">
                    <span class="material-symbols-outlined">
                        {{showPassword ? 'visibility_off' : 'visibility'}}
                    </span>
                </button>
            </div>
            <button type="button" class="btn btn-primary w-full mt-10" (click)="login()" [disabled]="processandoLogin">
                <span *ngIf="!processandoLogin">Entrar</span>
                <span *ngIf="processandoLogin">Carregando...</span>
            </button>
        </form>
        <a href="javascript:void(0)" class="text-brand-primary text-center block" (click)="abrirModalEsqueciSenha()">Esqueci a senha</a>
    </div>

    <app-esqueci-senha></app-esqueci-senha>
</main>
